export const LIVE_CHAT_COPY = {
  title: "Live chat",
  launcher: "Live Chat with us",
  empty: "Send us a message and we’ll be happy to help.",
  inputLabel: "Message",
  inputPlaceholder: "Type your message…",
  send: "Send",
  retry: "Retry",
  cancel: "Cancel",
  phoneLabel: "Phone number",
  phonePlaceholder: "Enter your phone number",
  sendOtp: "Send OTP",
  otpLabel: "One-time password",
  verifyOtp: "Verify OTP",
  resendOtp: "Resend OTP",
  changePhone: "Change phone number",
  invalidOtp: "Invalid or expired OTP. Please try again.",
  unsupportedVerification: "This verification method is not supported yet.",
  unavailable: "Live chat is temporarily unavailable. Please try again.",
  offline: "You’re offline. Messages can be retried when you reconnect.",
};

export const LIVE_CHAT_LIMITS = {
  maxMessageLength: 4000,
  historyPageSize: 50,
  historyRequestTimeoutMs: 10000,
  historyScrollThrottleMs: 1000,
  historyRetryDelayMs: 2 * 60 * 1000,
  bootstrapAttempts: 3,
  reconnectBaseDelayMs: 1000,
  reconnectMaxDelayMs: 30000,
  heartbeatIntervalMs: 25000,
  heartbeatAckTimeoutMs: 10000,
  resendCooldownSeconds: 60,
};

export const LIVE_CHAT_SOCKET_EVENTS = {
  message: "live_chat.message",
  heartbeat: "live_chat.heartbeat",
  heartbeatAck: "live_chat.heartbeat_ack",
};

export const LIVE_CHAT_SOCKET_CLOSE_CODES = {
  normal: 1000,
  browserOffline: 4000,
  heartbeatTimeout: 4001,
  unauthorized: 4401,
};

export const LIVE_CHAT_MODES = {
  public: "public",
  preview: "preview",
};
